import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { SET_EDIT_STATUS, SET_LOCK_STATUS } from "../../../redux/actions/types";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";

const NavbarOwner = () => {
  const dispatch = useDispatch();
  const variant = useSelector(
    (store) => store?.certificateVerification?.userType,
  );
  const userDetails = useSelector(
    (store) => store?.certificateVerification?.userInfo,
  );
  return (
    <div className="flex w-full items-center justify-center">
      <div className="mx-auto flex w-fit items-center gap-2 text-white">
        <div className="flex w-fit items-center gap-2 rounded-md bg-white/10 p-2">
          <img
            src="https://img.learntube.ai/public-assets/new%20Linkedin%20data/image%2011.png?updatedAt=1747309992449"
            loading="eager"
            alt=""
            width={24}
            height={24}
            className="h-6 w-6"
          />
          <p className="text-xs font-medium">LearnTube.ai</p>
        </div>
        <div className="h-[36px] w-[2px] bg-white/20" />
        <div className="flex flex-col items-center">
          <p className="text-[10px] text-white/50">backed by</p>
          <div className="flex items-center gap-1">
            <img
              src="https://img.learntube.ai/public-assets/post-payment-updates/use2460.svg?updatedAt=1728356838222"
              alt=""
              width={40}
              height={13}
              className="h-auto w-10"
            />
            <img
              src="https://img.learntube.ai/public-assets/post-payment-updates/text3075.svg?updatedAt=1728356926579"
              alt=""
              width={64}
              height={13}
              className="h-auto w-16"
            />
          </div>
        </div>
      </div>
      {variant === "owner" && (
        <div
          className="flex h-[36px] w-[36px] cursor-pointer items-center justify-center rounded-[6px] bg-[#4285F426] py-2 pl-2 pr-1"
          onClick={(e) => {
            Mixpanel.track(
              Constants.Mixpanel
                .CERTIFICATE_VERIFICATION_OWNER_PAGE_EDIT_BUTTON_CLICKED,
              { distinct_id: userDetails?.email },
            );
            dispatch({ type: SET_EDIT_STATUS, payload: true });
          }}
        >
          <img
            src="https://img.learntube.ai/public-assets/Certificate%20Verification%20Screen/Group%20(1).png?updatedAt=1750349661347"
            alt=""
          ></img>
        </div>
      )}
    </div>
  );
};

export default NavbarOwner;
